module.exports = {"body":"<p><strong>Autor</strong></p>\n<p>Hans König</p>\n<p><strong>Regie</strong></p>\n<p>Hans König (2013), Helge Tramsen (2014-2016)</p>\n<p><strong>Produktion</strong></p>\n<p>Frauke Wilhelm</p>\n<p><strong>verschiedene Besetzungen</strong></p>\n<p>mit Frauke Wilhelm, Nomena Struß, Mateng Pollkläsener,\nUlf Albrecht, Sarah Fritzsche-Harjes, Walter Pohl, Hans König, Egon Rammé, Martin Kruzig, Fred\nDrobnjak</p>\n<p><strong>Requisite</strong></p>\n<p>Rita Frische, Julia Schlecht, Marvin Otten, Julia Katzberg</p>\n<p><strong>Technik</strong></p>\n<p>Torben Wiedemeyer</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./projekte/theater.sidebar.md
// module id = 1026
// module chunks = 0